import { useMediaTasksDataForItem } from "./hooks/useMediaTasksDataForItem";
import { MediaTasksSectionView } from "./MediaTasksSectionView";
import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";

interface MediaTasksSectionForSearchProps {
  itemNo: string;
}

/**
 * Container component for all-medias tasks (search page)
 * Fetches data across all medias and passes to presentation component
 */
export const MediaTasksSectionForSearch = ({
  itemNo,
}: MediaTasksSectionForSearchProps) => {
  const storeId = useStoreId();
  const tasksData = useMediaTasksDataForItem(storeId, itemNo);

  return (
    <MediaTasksSectionView
      {...tasksData}
      onLoadMore={tasksData.fetchNextPage}
      testId="media-tasks-list-item-search"
    />
  );
};
